import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Multiselect } from 'multiselect-react-dropdown';
import {
  getLeadByID,
  setNewDataLead,
} from '../../redux/reduxActions/leadActions';
import { setObjectiveSelector, setSelectors, showToastError } from '../utils';

const LeadClassifications = (props) => {
  const [workTypeSelected, setWorkType] = useState('');
  const [workTechSelected, setWorkTech] = useState('');
  const [proposalTypeSelected, setProposalType] = useState('');
  const [prioritySelected, setPriority] = useState({});
  const [funnelStatus, setFunnelStatus] = useState('');
  const {
    priorities,
	  workType,
	  workTech,
	  selectedLead: { work_type, work_technology },
	  funnelStatuses,
	  selectedLead,
	  proposalTypes,
  } = props;
  const SetUpWorkData = () => {
  	const workTypeData = workTypeSelected ? workTypeSelected.map((item) => item.id)
		  : work_type;
	  const workTechData = workTechSelected ? workTechSelected.map((item) => item.id)
		  : work_technology;
	  if (!proposalTypeSelected
		  || !prioritySelected
		  || !workTechData
		  || !workTypeData
	  ) {
		  showToastError('Fill in required fields');
		  return;
	  }
  	const data = {
		  priority: prioritySelected,
		  work_type: workTypeData,
		  work_technology: workTechData,
		  funnel_status: funnelStatus.id,
		  proposal_type: parseInt(proposalTypeSelected, 10),
	  };
	  props.setNewDataLead(selectedLead.id, data, props.history.push, false);
  };
  useEffect(() => {
    // console.log('hg')
    props.getLeadByID(props.match.params.id);
  }, []);
  useEffect(() => {
	  setPriority(selectedLead.priority || '');
	  setProposalType(selectedLead.proposal_type || '');
	  setFunnelStatus(funnelStatuses
		  .find((item) => item.name === 'LeadClassifided'));
  }, [props]);
  function setWorkTechSelected() {
	  if (work_technology && workTech.length) {
		  return work_technology.map((item) => workTech.find((inner) => inner.id === item));
	  }
	  return [];
  }
  function setWorkTypeSelected() {
    if (work_type && workType.length) {
      return work_type.map((item) => workType.find((inner) => inner.id === item));
    }
    return [];
  }
  return (
    <div>
      <div>
        <div className="lead__container" style={{ minHeight: 'auto' }}>
          <h3 style={{ color: '#383838', marginBottom: 10 }}>Set Lead Classification</h3>
          <div className="lead__container__inner" style={{ marginBottom: 16 }}>
            <p className="lead__title">
			        Work Type
              <span style={{ color: 'red' }}>*</span>
            </p>
            <div
              style={{ width: '50%' }}
            >
              <Multiselect
                options={workType}
                selectedValues={setWorkTypeSelected()}
                onSelect={(event) => {
				          setWorkType(event);
			          }}
                onRemove={(event) => {
	                setWorkType(event);
                }}
                displayValue="name"
              />
            </div>

          </div>
          <div className="lead__container__inner" style={{ marginBottom: 16 }}>
            <p className="lead__title">
			        Work Tech
              <span style={{ color: 'red' }}>*</span>
            </p>
            <div
              style={{ width: '50%' }}
            >
              <Multiselect
                options={workTech}
                selectedValues={setWorkTechSelected()}
                onSelect={(event) => {
	                setWorkTech(event);
			          }}
                onRemove={(event) => {
	                setWorkTech(event);
                }}
                displayValue="name"
              />
            </div>
          </div>
          <div className="lead__container__inner">
            <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
              <li>Have we done similar work?</li>
              <li> Affects Proposal Type</li>
              <li> Free / when are freed developers who can complete the project?</li>
              <li> The country?</li>
              <li> Payment history?</li>
              <li> How clear is the original description?</li>
            </ul>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
			        Proposal Type
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group style={{ width: '50%' }} controlId="formGridState">
              <Form.Control
                as="select"
                value={proposalTypeSelected}
                onChange={({ target: { value } }) => { setProposalType(value); }}
              >
                <option key="" value="">none</option>
                {setSelectors(proposalTypes)}
              </Form.Control>
            </Form.Group>
          </div>
          <div className="lead__container__inner">
            <p className="lead__title">
			        Priority
              <span style={{ color: 'red' }}>*</span>
            </p>
            <Form.Group style={{ width: '50%' }} controlId="formGridState">
              <Form.Control
                as="select"
                value={prioritySelected}
                onChange={({ target: { value } }) => { setPriority(value); }}
              >
                <option key="" value="">none</option>
                {setObjectiveSelector(priorities)}
              </Form.Control>
            </Form.Group>
          </div>
          <Button
            onClick={() => SetUpWorkData()}
            variant="primary"
            style={{ marginLeft: '88%', marginTop: 20 }}
            className="main-button-filled"
          >
						Save
          </Button>
        </div>
      </div>
    </div>
  );
};
export default connect((store) => ({
  selectedLead: store.leadReducer.selectedLead,
  priorities: store.skillsReducer.priorities,
  funnelStatuses: store.leadReducer.funnelStatuses,
  funnelType: store.leadReducer.funnelType,
  workType: store.leadReducer.workType,
  workTech: store.leadReducer.workTech,
  responsible: store.leadReducer.responsible,
  proposalTypes: store.leadReducer.proposalTypes,
}), { setNewDataLead, getLeadByID })(LeadClassifications);
